export default "__VITE_ASSET__CgO8mpx7__"